import './App.scss';
import Header from './components/Header';
import Presentation from './components/Presentation';
import Education from './components/Education';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <main className='main'>
        <div className='block-container'>
          <Presentation />
          <Education />
        </div>
        <div className='block-container'>
          <Experience />
          <Skills />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
